import { render, staticRenderFns } from "./UpdateSchools.vue?vue&type=template&id=8cbed458&scoped=true&"
import script from "./UpdateSchools.vue?vue&type=script&lang=js&"
export * from "./UpdateSchools.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSchools.vue?vue&type=style&index=0&id=8cbed458&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbed458",
  null
  
)

component.options.__file = "UpdateSchools.vue"
export default component.exports